import type { ComponentPropsWithRef, ReactNode } from "react";
import { Fragment, forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";

export interface PricingBlock1Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const PricingBlock1 = forwardRef<HTMLDivElement, PricingBlock1Props>(
  ({ header, content, footer, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 wb-items-center wb-text-center md:wb-gap-5 md:wb-max-w-xl wb-mx-auto">
                {header}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-6 md:wb-grid md:wb-grid-cols-3 md:wb-gap-[1.875rem]">
                {content}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock
                as={Fragment}
                block={footer}
                render={footer => (
                  <div className="wb-mx-auto wb-flex wb-flex-col wb-justify-center wb-gap-10 md:wb-gap-16">
                    <div className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-8 wb-text-center">
                      {footer}
                    </div>
                  </div>
                )}
              />
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

PricingBlock1.displayName = "PricingBlock1";
